import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import ThemeControl from '../../../../components/ThemeControl/ThemeIcon';
import classes from './ThemeToggle.styles.less';
export default function ThemeToggle({ className, theme, onToggle, label = 'mode' }) {
    return (_jsxs("button", { type: "button", onClick: onToggle, className: cx(classes.control, classes[theme], className), children: [_jsx(ThemeControl, { theme: theme === 'light' ? 'dark' : 'light', size: 18 }), _jsxs("div", { className: classes.label, children: [theme === 'light' ? 'Dark' : 'Light', " ", label] })] }));
}
